// src/components/experts/AboutTeam.jsx
import React from 'react';
import { motion } from 'framer-motion';

const AboutTeam = () => {
  const coFounders = [
    {
      name: 'Dr. Sarah Miller',
      title: 'Co-Founder & Chief Medical Officer',
      bio: 'With a profound understanding of the challenges faced by medical aspirants, Dr. Miller envisioned a platform that goes beyond traditional coaching. Her extensive experience in medical education and her passion for nurturing talent have been instrumental in shaping our curriculum and pedagogical approach. She believes in empowering students with not just knowledge, but also the critical thinking and problem-solving skills essential for success in their careers.',
      image: '/images/sarah_miller.jpg', // Replace with actual image path
    },
    {
      name: 'Mr. James Wilson',
      title: 'Co-Founder & CEO',
      bio: 'Driven by a vision to create accessible and high-quality learning resources, Mr. Wilson brings a wealth of experience in technology and education management. He is committed to leveraging innovative tools and strategies to enhance the learning experience and provide students with a seamless and engaging platform. His focus on user-centric design and continuous improvement ensures that our platform remains at the forefront of online medical education.',
      image: '/images/james_wilson.jpg', // Replace with actual image path
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.section
      className="py-16 bg-light rounded-lg shadow-md p-8"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.h2
        className="text-3xl font-bold text-gray-800 mb-8 text-center"
        variants={itemVariants}
      >
        Meet Our Visionaries
      </motion.h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {coFounders.map((founder, index) => (
          <motion.div
            key={index}
            className="text-center"
            variants={itemVariants}
          >
            <div className="relative w-32 h-32 mx-auto rounded-full overflow-hidden mb-4">
              <img
                src={founder.image}
                alt={founder.name}
                className="object-cover w-full h-full"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">{founder.name}</h3>
            <p className="text-gray-600 text-center mb-3">{founder.title}</p>
            <p className="text-gray-700 leading-relaxed">{founder.bio}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default AboutTeam;